import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M11.36 6.1V18H9.917v-5.559H4.22V18H2.776V6.1H4.22v5.134h5.695V6.1h1.445Zm6.65 12.104c-2.16 0-3.281-.816-4.148-1.768l.884-.833c.748.816 1.7 1.445 3.196 1.445 1.547 0 2.805-.68 2.805-2.244v-.493c0-1.581-1.598-2.074-2.686-2.074h-1.173v-1.105h1.173c1.088 0 2.295-.476 2.295-1.768v-.408c0-1.377-1.122-1.921-2.414-1.921s-2.244.561-3.111 1.36l-.816-.816c.969-.952 2.227-1.683 3.995-1.683 2.074 0 3.757 1.122 3.757 2.907v.612c0 1.139-1.054 1.989-2.091 2.193 1.037.119 2.516 1.054 2.516 2.55v.731c0 1.887-1.768 3.315-4.182 3.315Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextH3Icon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'textH3'),
) as IconWithRender;

TextH3Icon.displayName = 'TextH3Icon';
TextH3Icon.propTypes = Icon.propTypes;
TextH3Icon.renderIcon = (props) => <TextH3Icon {...props} />;
export default TextH3Icon;
